import { render, staticRenderFns } from "./ContainerReturn.vue?vue&type=template&id=be1f9a94&scoped=true"
import script from "./ContainerReturn.vue?vue&type=script&lang=js"
export * from "./ContainerReturn.vue?vue&type=script&lang=js"
import style0 from "./ContainerReturn.vue?vue&type=style&index=0&id=be1f9a94&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1f9a94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be1f9a94')) {
      api.createRecord('be1f9a94', component.options)
    } else {
      api.reload('be1f9a94', component.options)
    }
    module.hot.accept("./ContainerReturn.vue?vue&type=template&id=be1f9a94&scoped=true", function () {
      api.rerender('be1f9a94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/ContainerReturn.vue"
export default component.exports